import { render, staticRenderFns } from "./FcoLink.vue?vue&type=template&id=04dcdf8e&"
import script from "./FcoLink.vue?vue&type=script&lang=js&"
export * from "./FcoLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports